module.exports = __webpack_public_path__ + "img/KE.215764a3.svg";